import {
  StyleSheet,
  Dimensions,
  Platform
} from 'react-native'

import {
  Fonts,
  Colors
} from '@vfgroup-oneplatform/foundation/Components/Themes'

const SCREEN_WIDTH = Dimensions.get('screen').width

const styles = StyleSheet.create({
  boldTitle: {
    fontSize: Fonts.size.h4,
    ...Fonts.type.bold,
    // color: Colors.dark_grey,
    marginTop: 20,
    // marginBottom: 16
  },
  graySubtitle: {
    fontSize: Fonts.size.regularSmall,
    // color: Colors.dark_grey,
    // marginVertical: 16,
    width: 'auto',
  },
  emailButton: {
    position: 'absolute'
  },
  emailFormat: theme => ({
    fontSize: Fonts.size.regularSmall,
    color: theme.colors.textColor,
    // marginVertical: 16,
    width: 'auto',
    borderBottomColor: theme.colors.textColor,
    borderBottomWidth: 1,
  }),
  emailContainer: {
    flex: 1,
    marginBottom: 32
  },
  boldSubtitle: {
    fontSize: Fonts.size.h5,
    ...Fonts.type.bold,
    // color: Colors.black,
    paddingVertical: 8
  },
  image: {
    width: SCREEN_WIDTH - 40,
    height: 265,
    margin: 20,
    borderRadius: 10
  },
  cardTitle: {
    color: Colors.white,
    fontSize: Fonts.size.regular
    // marginBottom: 20,
  },
  cardDescription: {
    color: Colors.white,
    fontSize: Fonts.regularSmall
  },
  phoneNumber: {
    paddingTop: 5,
    color: 'gray'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  borderBottom: {
    borderBottomColor: Colors.white_two,
    borderBottomWidth: 1
  },
  underlinedText: theme => ({
    fontSize: Fonts.size.medium,
    lineHeight: 18,
    color: theme.colors.textColor,
    textDecorationStyle: 'solid',
    textDecorationLine: 'underline',
    textDecorationColor: theme.colors.textColor,
    paddingRight: 10
  }),
  buttonStyle: {
    paddingHorizontal: 16,
    paddingVertical: 6,
    width: '45%'
  },
  cardStyle: {
    marginHorizontal: Platform.OS == 'web' && Dimensions.get('window').width > 700 ? 0 : -10,
  },
  copyButton: {
    paddingHorizontal: 16,
    paddingVertical: 6,
    marginLeft: -15,
  },
  bottomPadding: {
    paddingBottom: 20,
  },
  locationButton: {
    width: '75%',
    lineHeight: 16,
    fontSize: Fonts.size.regularSmall,
  },
  contactContainer: {
    marginTop: 28,
    marginBottom: 16,
  }
})

export default styles